export const getCountryCode = () => {
    const countryCode = window.navigator.language.split("-")[1];
    return countryCode ? countryCode : "BR";
};